import { render, staticRenderFns } from "./GuideQuickQa.vue?vue&type=template&id=a4816500&scoped=true"
import script from "./GuideQuickQa.vue?vue&type=script&lang=js"
export * from "./GuideQuickQa.vue?vue&type=script&lang=js"
import style0 from "./GuideQuickQa.vue?vue&type=style&index=0&id=a4816500&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4816500",
  null
  
)

export default component.exports